
let campaignsApi = {
    async get(token, companyId, filters){
        let response = await window.axios.get('/api/campaign', {
            params:{
                api_token:token,
                company_id:companyId,
                relationships:[],
                ...filters
            }
        });
        return response.data;
    },
    async getExtraFields(token, companyId, params={}){
        let response = await window.axios.get('/api/fieldsCampaign', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
    async getExtraFieldsOptions(token, companyId, params={}){
        let response = await window.axios.get(`/api/fieldsCampaign/options`, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
}

export default campaignsApi